export default __webpack_public_path__ + "images/logoSixGldn.a4e4696a91a89cdf925857caa144786c.svg"